import * as React from "react";
import moment from "moment";
import useTranslation from "../../hooks/useTranslation";

import './Time.scss';

const inputMainProps = ['required', 'name', 'value', 'onChange', 'placeholder', 'min', 'max'];

function Time(props) {
    const { t } = useTranslation();

    const getMainProps = (elementProps) => {
        const result = {};
        Object.entries(props).forEach(([propName, value]) => {
            if (/value|min|max/.test(propName) && value) {
                const time = moment(value, ['H:mm', 'HH:mm'], true); // akceptuj obojí formáty
                value = time.isValid() ? time.format('HH:mm') : value;
            }
            if (elementProps.includes(propName)) {
                result[propName] = value;
            }
        });
        return result;
    };
    const handleChange = (e) => {
        props.onChange(e.target.name, e.target.value);
    };

    const disabled = props.disabled || false;
    let className = 'FormInput FormTime';
    if (props.required) className += ' required';

    const key = props.name;

    return (
        <div className={className}>
            {props.label !== false && <label htmlFor={key}>{props.label || t(props.name)}</label>}
            <input
                id={key}
                type="time"
                {...getMainProps(inputMainProps)}
                onChange={handleChange}
                disabled={disabled}
            />
        </div>
    );
}

export default Time;
